module.exports = __webpack_public_path__ + "img/id.4080fb4e.png";